export type TimeZone = {
	name: string;
	symbol: string;
};
